import loadable from '@loadable/component'

export default [
  {
    path: '/coinagency/manageQuickReply',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-manageQuickReply" */ '~/pages/Coinagency/pages/manageQuickReply'
        )
    ),
  },
  {
    path: '/coinagency/firstRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-firstRecharge" */ '~/pages/Coinagency/pages/firstRecharge'
        )
    ),
  },
  {
    path: '/coinagency/firstRechargeRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-firstRechargeRule" */ '~/pages/Coinagency/pages/firstRechargeRule'
        )
    ),
  },
  {
    path: '/coinagency/firstRechargeHow',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-firstRechargeHow" */ '~/pages/Coinagency/pages/firstRechargeHow'
        )
    ),
  },
  {
    path: '/coinagency/payoutAccount',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-payoutAccount" */ '~/pages/Coinagency/pages/payoutAccount'
        )
    ),
  },
  {
    path: '/coinagency/createPayoutAccount',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-createPayoutAccount" */ '~/pages/Coinagency/pages/createPayoutAccount'
        )
    ),
  },
  {
    path: '/coinagency/supportPayoutCountry',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-supportPayoutCountry" */ '~/pages/Coinagency/pages/supportPayoutCountry'
        )
    ),
  },
  {
    path: '/coinagency/signup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencySignup" */ '~/pages/Coinagency/Signup'
        )
    ),
  },
  {
    path: '/coinagency/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyInvitation" */ '~/pages/Coinagency/Invitation'
        )
    ),
  },
  {
    path: '/coinagency/agencywallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencyWallet" */ '~/pages/Coinagency/AgencyWallet'
        )
    ),
  },
  {
    path: '/coinagency/recharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencyRecharge" */ '~/pages/Coinagency/AgencyRecharge'
        )
    ),
  },
  {
    path: '/coinagency/sell/:restCurrency',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyAgencySellCoins" */ '~/pages/Coinagency/SellCoins'
        )
    ),
  },
  {
    path: '/coinagency/distributorManage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyDistributorManage" */ '~/pages/Coinagency/DistributorManage'
        )
    ),
  },
  // 超级币商分销页面
  {
    path: '/coinagency/DistributorManageSuper',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyDistributorManageHighest" */ '~/pages/Coinagency/DistributorManageSuper'
        )
    ),
  },
  {
    // 币商销售数据
    path: '/coinagency/sales-data',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-coinagency-sales-data" */ '~/pages/Coinagency/pages/SalesData'
        )
    ),
  },
  {
    // 币商金币详情记录
    path: '/coinagency/coin-detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-coinagency-coin-detail" */ '~/pages/Coinagency/pages/CoinDetail'
        )
    ),
  },
  {
    // 币商新用户推荐页
    path: '/coinagency/newcomer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-coinagency-newcomer" */ '~/pages/Coinagency/pages/Newcomer'
        )
    ),
  },
  {
    // 币商历史客户页
    path: '/coinagency/history-customer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-coinagency-history-customer" */ '~/pages/Coinagency/pages/HistoryCustomer'
        )
    ),
  },
]
